import i18next from "i18next";
import { initReactI18next } from "react-i18next";

i18next.use(initReactI18next).init({
    fallbackLng: "tr",
    lng: "tr",
    resources: {
        en: {
            translations: require("./locales/en/translations.json")
        },
        tr: {
            translations: require("./locales/tr/translations.json")
        }
    },
    ns: ["translations"],
    defaultNs: "translations"
})

i18next.languages = ["tr", "en"];

export default i18next;